// extracted by mini-css-extract-plugin
module.exports = {"label":"Switch_label__hezD2","input":"Switch_input__Sn1hs","waveAnimation":"Switch_waveAnimation__RH32R","marquee":"Switch_marquee__zf2Bs"};